import { render, staticRenderFns } from "./IconSlide.vue?vue&type=template&id=fd7fe2b6&scoped=true"
import script from "./IconSlide.vue?vue&type=script&lang=js"
export * from "./IconSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7fe2b6",
  null
  
)

export default component.exports